(function () {
  'use strict';

  if (window.__chicsewHeaderAccountMenuInitialized) return;
  window.__chicsewHeaderAccountMenuInitialized = true;

  function closeMenu(menu) {
    if (!menu) return;
    menu.dataset.open = 'false';
    const toggle = menu.querySelector('[data-header-account-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function closeOtherMenus(activeMenu) {
    document.querySelectorAll('[data-header-account-menu]').forEach(function (menu) {
      if (menu !== activeMenu) closeMenu(menu);
    });
  }

  function handleDocumentClick(event) {
    const toggle = event.target.closest('[data-header-account-toggle]');
    if (toggle) {
      const menu = toggle.closest('[data-header-account-menu]');
      const shouldOpen = menu.dataset.open !== 'true';
      closeOtherMenus(menu);
      menu.dataset.open = shouldOpen ? 'true' : 'false';
      toggle.setAttribute('aria-expanded', String(shouldOpen));
      return;
    }
    if (!event.target.closest('[data-header-account-menu]')) closeOtherMenus(null);
  }

  function handleKeydown(event) {
    if (event.key !== 'Escape') return;
    const openMenu = document.querySelector('[data-header-account-menu][data-open="true"]');
    if (!openMenu) return;
    const toggle = openMenu.querySelector('[data-header-account-toggle]');
    closeMenu(openMenu);
    if (toggle) toggle.focus();
  }

  document.addEventListener('click', handleDocumentClick);
  document.addEventListener('keydown', handleKeydown);
})();
